import { EffectDef, makeGain } from './types';

/** Feedback delay with dry/wet blend. */
export const delay: EffectDef = {
  type: 'delay',
  name: 'Delay',
  params: [
    { key: 'time', label: 'Time', min: 20, max: 1000, default: 375, step: 1, unit: 'ms' },
    { key: 'feedback', label: 'Fdbk', min: 0, max: 0.9, default: 0.35, step: 0.01 },
    { key: 'wet', label: 'Wet', min: 0, max: 1, default: 0.3, step: 0.01 },
  ],
  build(ctx, p) {
    const input = makeGain(ctx, 1);
    const output = makeGain(ctx, 1);
    const dry = makeGain(ctx, 1 - p.wet);
    const wetIn = makeGain(ctx, 1);
    const delayNode = ctx.createDelay(2);
    const feedback = makeGain(ctx, p.feedback);
    const wetOut = makeGain(ctx, p.wet);

    input.connect(dry);
    dry.connect(output);
    input.connect(wetIn);
    wetIn.connect(delayNode);
    delayNode.connect(wetOut);
    wetOut.connect(output);
    delayNode.connect(feedback);
    feedback.connect(delayNode);

    const apply = (params: Record<string, number>) => {
      delayNode.delayTime.setTargetAtTime(params.time / 1000, ctx.currentTime, 0.05);
      feedback.gain.value = params.feedback;
      dry.gain.value = 1 - params.wet;
      wetOut.gain.value = params.wet;
    };
    apply(p);

    return {
      input,
      output,
      update: apply,
      dispose: () => {
        delayNode.disconnect();
        feedback.disconnect();
        dry.disconnect();
        wetIn.disconnect();
        wetOut.disconnect();
        input.disconnect();
        output.disconnect();
      },
    };
  },
};